import { setupDeleteConfirmation } from '../lib/delete-confirmation';

document.addEventListener('DOMContentLoaded', () => {
    setupDeleteConfirmation('.form-cancel-contract-line', {
        title: 'Cancel line',
        text: 'Are you sure you want to cancel this contract line? This action cannot be undone.',
        confirmButtonText: 'Yes, cancel it',
        cancelButtonText: 'Keep it'
    });
});
